import EmployeeList from './list/EmployeeList.vue';
import ViewEmployee from './view/ViewEmployee.vue';
import AddEmployee from './add/AddEmployee.vue';

export default [
    { path: '', component: EmployeeList },
    { path: 'list', component: EmployeeList },
    { path: 'view/:id', component: ViewEmployee },
    { path: 'add', component: AddEmployee }
]